import { render, staticRenderFns } from "./OverviewRequisition.vue?vue&type=template&id=27108d01&scoped=true&"
import script from "./OverviewRequisition.vue?vue&type=script&lang=js&"
export * from "./OverviewRequisition.vue?vue&type=script&lang=js&"
import style0 from "./OverviewRequisition.vue?vue&type=style&index=0&id=27108d01&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27108d01",
  null
  
)

export default component.exports